<template>
  <div class="cactus--autocomplete">
    <div v-show="!addNew">
      <v-autocomplete
        v-model="selected"
        :loading="loading"
        v-bind="$attrs"
        :items="items"
        :item-text="itemText"
        :append-icon="addNewIcon"
        @click:append="addNew = true"
        :search-input.sync="search"
        :multiple="multiple"
        cache-items
        autocomplete="off"
        return-object
        :label="label">
      </v-autocomplete>
    </div>
    <div v-if="addNew">
      <v-text-field
        v-model="newItem"
        append-icon="check_circle"
        box
        append-outer-icon="close"
        :label="addNewLabel"
        type="text"
        @click:append="submitNewItem"
        @click:append-outer="cancelAddNew"
      ></v-text-field>
    </div>
  </div>
</template>

<script>
import _debounce from 'lodash/debounce'
export default {
  props: {
    apiService: {
      required: true
    },
    apiMethodName: {
      type: String,
      required: false,
      default: 'get'
    },
    value: {
      required: true
    },
    apiItems: {
      required: false,
      default: undefined
    },
    loadImmediate: {
      required: false,
      default: false
    },
    label: {
      required: false,
      default: 'Search'
    },
    addNewLabel: {
      required: false,
      default: 'Create New'
    },
    searchProp: {
      type: String,
      required: false,
      default: 'name'
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    fuzzySearch: {
      type: Boolean,
      require: false,
      default: true
    },
    itemText: {
      required: false,
      default: 'name'
    },
    addNewItem: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      addNew: false,
      newItem: undefined,
      items_: [],
      selected: undefined,
      search: '',
      loading: false
    }
  },
  computed: {
    items: {
      get () {
        if (this.apiItems !== undefined) {
          return this.apiItems
        }
        return this.items_
      },
      set (value) {
        this.items_ = value
      }
    },
    addNewIcon () {
      return this.addNewItem ? 'add_circle' : undefined
    },
    filterParams () {
      return {
        [this.searchProp]: {
          filter: this.fuzzySearch ? 'like' : 'equals',
          value: this.fuzzySearch ? `${this.search}*` : this.search
        }
      }
    }
  },
  async created () {
    if (this.loadImmediate && this.apiItems === undefined) {
      const params = {
        limit: undefined
      }
      this.loading = true
      const {data} = await this.apiService[this.apiMethodName]({params})
      this.items = data
      this.loading = false
    }
    this.selected = this.value
  },
  methods: {
    get: _debounce(async function (val) {
      if (this.loadImmediate) {
        return
      }
      this.loading = true
      const {data} = await this.apiService[this.apiMethodName]({filterParams: this.filterParams})
      this.loading = false
      this.items = data
    }, 500),
    cancelAddNew () {
      this.newItem = undefined
      this.addNew = false
    },
    async submitNewItem () {
      if (this.newItem === undefined) return
      else if (this.newItem.trim() === '') return
      const payload = {[this.itemText]: this.newItem}
      const {data} = await this.apiService.create(payload)
      this.appendNewItem(data)
      this.selected = data
      this.cancelAddNew()
    },
    appendNewItem (item) {
      if (this.apiItems) {
        this.$emit('new', item)
      } else {
        this.items.push(item)
      }
    }
  },
  watch: {
    search (val) {
      val && val.trim() !== '' && this.apiItems === undefined && this.get(val)
    },
    selected (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.selected = val
    }
  }
}
</script>

<style>

</style>
